import ActivityTable from './ActivityTable';

export default ActivityTable;